import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {mainPath as MainPath} from '../../../routes/paths';

const SideBgFooter = () => {
    const {t} = useTranslation();

    return (
        <div className={'side-bg__footer'}>
            <Link to={MainPath.policy}>{t('SideBgFooter.privacy')}</Link>
            <p>{t('SideBgFooter.copyright', {year: new Date().getFullYear()})}</p>
        </div>
    );
};

export default SideBgFooter;
